import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';

import { createFolder } from '../../api/folders';
import { quizzesQueryKey } from './useQuizzes';

export function useCreateFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFolder,
    onSettled: handleOnSettled(queryClient),
    onSuccess: () => {
      queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
    onError: (error) => {
      apiToaster([], QuizToastActions.CREATE_FOLDER, error);
    },
  });
}

const handleOnSettled = (queryClient: QueryClient) => () =>
  queryClient.invalidateQueries(quizzesQueryKey.quiz);
